import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RequestMapperService} from "../request-mapper.service";
import {ReviewComponent} from "./review/review.component";

const routes: Routes = [
	{
		path: RequestMapperService.BASE_RELATIVE_URL,
		component: ReviewComponent
	}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReviewRoutingModule { }
